import logo from "../assets/logo.png";
import { business } from "../data/siteData";

function Logo({ className = "" }) {
  return <img src={logo} alt={business.name} className={`logo ${className}`} />;
}

export default Logo;
